/**
 * Vuex getters for the "member" module.
 *
 * Thin state accessors exposing user-search results and reputation-score
 * history as-is.
 */
export default {
  getUsersData: (state) => state.usersData,
  getUserReputationScores: (state) => state.userReputationScores,
};
